//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      blocks: [{
        title: 'Gifts for %MINPRICE%',
        blockName: 'gifts-for-45',
        products: {
          'classics3-nonpol': {},
          'renegades-nonpol': {},
          'sierras-nonpol': {}
        },
        skuField: 'skuNonPol'
      }, {
        title: 'Gifts for %MINPRICE%',
        blockName: 'gifts-for-70',
        products: {
          'classics3-pol': { subtitle: 'with Polarised Lenses' },
          'renegades-pol': { subtitle: 'with Polarised Lenses' },
          'sierras-pol': { subtitle: 'with Polarised Lenses' }
        },
        skuField: 'skuPol'
      }, {
        title: 'Limited Edition Gifts',
        blockName: 'gifts-le',
        products: {
          'renegades-le_rfu': { title: 'RFU 150 Renegades™', button: 'Gift RFU 150 Renegades™' },
          'renegades-le_woodsy': { title: 'Woodsy Renegades™', button: 'Gift Woodsy Renegades™' },
          'vanguards-le_woodsy': { title: 'Woodsy Vanguards™', button: 'Gift Woodsy Vanguards™' }
        },
        isLE: true
      }, {
        title: 'Gifts that Perform',
        blockName: 'gifts-that-perform',
        products: {
          'vulcans-tf': { title: 'Vulcans™' },
          'velans-tf': { title: 'Velans™' },
          snipers: {},
          vanguards: {}
        }
      }]
    }
  },
  head () {
    return {
      title: this.getTitle('Gift SunGod'),
      meta: [
        ...this.getDescription('Give the gift of SunGod'),
        { hid: 'og:title', property: 'og:title', content: this.getTitle('Gift SunGod') },
        { hid: 'og:image', property: 'og:image', content: `${this.$config.staticAssetURL}/images/sungod18/gifts/gifts-share-preview.jpg` }
      ]
    }
  },
  computed: {
    physicalInStock () {
      return this.$store.getters['product/isInStock']('gc_card')
    }
  },
  mounted () {
    if (this.$route.query.scrollTo) {
      this.$scrollTo('#giftcard')
    }
  },
  methods: {
    scrollToGiftCard (price) {
      this.$refs.giftcard.setValue(price)
      this.$scrollTo('#giftcard')
    }
  }
}
